import $http from '../connectionProxy'

export const getStudents = () => {
  return $http.get('/responsibles_area/students')
}
